import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { DataConnections } from '~src/datasource/dataConnection/resources/DataConnections';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataConnectionInWorkbookContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../../../spacesPlatform/contentDefinitions/getDefaultFilters';

// TFS 829184- these all need validating!
export const DataConnectionInDatasourceDefinition: ExplorableItemDefinition = {
  itemType: 'connection',
  pluralName: Messages.connections,
  singularName: Messages.connection,
  emptyStateMessage: Messages.connectionsEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['dataconnection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return DataConnections.all().withExtraParams(DataConnectionInWorkbookContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
